export const moveItem = (list, from, to) => {
	const next = [...list];
	const [moved] = next.splice(from, 1);
	next.splice(to, 0, moved);
	return next;
};

// Returns the reordered list, or null when the drop is outside the list or a no-op.
export const reorderOnDragEnd = ({ source, destination }, list) => {
	if (!destination || destination.index === source.index) return null;
	return moveItem(list, source.index, destination.index);
};
